import { formatCurrency } from '@/utils/misc';

type PoolAmountDisplayProps = {
  amount?: string | null;
  placeholder?: string;
  showLabel?: boolean;
  label?: string;
  amountSize?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
};

export function PoolAmountDisplay({
  amount,
  placeholder = '$---,---',
  showLabel = false,
  label = 'Pool Amount',
  amountSize = 'md',
  className = '',
}: PoolAmountDisplayProps) {
  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-3xl',
    lg: 'text-4xl',
    xl: 'text-5xl',
  };

  const amountSizeClass = sizeClasses[amountSize];

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {showLabel && <div className={`text-[#113D7B] text-sm font-medium font-avenir`}>{label}</div>}
      <div className={`text-black ${amountSizeClass} font-medium font-avenir`}>
        {amount ? formatCurrency(amount) : placeholder}
      </div>
    </div>
  );
}
